import Icon from '@uikit/components/Icon/Icon';
import Link from '@uikit/components/Link/Link';
import { categoryConfigMap } from './config';
import { joinNonEmpty } from './helpers';
import type { WaermwendeProjectInfoProps } from './types';
import styles from './WaermwendeProjectInfo.module.scss';

const DataItems = ({ children }: React.PropsWithChildren) => {
  return <dl className={styles.dataItems}>{children}</dl>;
};

const DataItem = ({
  label,
  detail,
}: {
  label: string;
  detail: React.ReactNode;
}) => {
  return (
    <div className={styles.dataItem}>
      <dt className={styles.dataItemLabel}>{label}</dt>
      <span className={styles.dots} aria-hidden="true" />
      <dd className={styles.dataItemDetail}>{detail}</dd>
    </div>
  );
};

export const WaermwendeProjectInfo = ({
  backButtonPath,
  title,
  subTitle,
  category,
  constructionStart,
  operationStart,
  capacity,
  city,
  postalCode,
  street,
  houseNumber,
}: WaermwendeProjectInfoProps) => {
  const categoryConfig = categoryConfigMap[category];
  const CategoryIcon = categoryConfig?.icon;

  const firstAddressPart = joinNonEmpty([street, houseNumber], ' ');
  const secondAddressPart = joinNonEmpty([postalCode, city], ' ');
  const address = joinNonEmpty([firstAddressPart, secondAddressPart], ', ');

  return (
    <div className={styles.base}>
      <div className={styles.header}>
        {backButtonPath && (
          <Link
            className={styles.backButton}
            to={backButtonPath}
            aria-label="Zurück"
          >
            <Icon variant="action/arrow-left" size="iconSize18" />
            <span className={styles.backButtonLabel}>Zurück</span>
          </Link>
        )}
        <div className={styles.category}>
          {CategoryIcon && <CategoryIcon className={styles.icon} />}
          <span className={styles.categoryLabel}>{categoryConfig?.label}</span>
        </div>
      </div>
      <hgroup>
        <h1 className={styles.title}>{title}</h1>
        <h2 className={styles.subTitle}>{subTitle}</h2>
      </hgroup>

      <DataItems>
        <DataItem label="Baubeginn" detail={constructionStart} />
        <DataItem label="Inbetriebnahme" detail={operationStart} />
        <DataItem label="Leistung" detail={capacity} />
        <DataItem label="Standort" detail={address} />
      </DataItems>
    </div>
  );
};
